import React from 'react';
import { Clipboard, Quote } from 'lucide-react';
import { Button } from './ui/button';
import { ButtonTooltip, TooltipProvider } from './ui/tooltip';
import { useLocale } from '../contexts/LocaleContext';

type CommentMessageHoverActionsProps = {
  onQuote?: () => void;
  onCopy: () => void;
  className?: string;
};

export const CommentMessageHoverActions: React.FC<CommentMessageHoverActionsProps> = ({
  onQuote,
  onCopy,
  className = '',
}) => {
  const { t } = useLocale();

  return (
    <TooltipProvider>
      <div
        className={`absolute bottom-0 right-0 flex items-center gap-0.5 rounded-md bg-card/95 p-0.5 opacity-0 shadow-sm transition-opacity group-hover/comment-message:opacity-100 group-focus-within/comment-message:opacity-100 [@media(hover:none)]:opacity-100 ${className}`.trim()}
        onClick={(event) => event.stopPropagation()}
      >
        {onQuote ? (
          <ButtonTooltip tooltip={t('quote_in_reply_tooltip')} side="top">
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="group/quote-action h-7 w-7"
              aria-label={t('quote_in_reply')}
              onClick={(event) => {
                event.stopPropagation();
                onQuote();
              }}
            >
              <Quote className="h-3.5 w-3.5 transition-[transform,color] duration-300 group-hover/quote-action:-translate-y-0.5 group-hover/quote-action:text-[var(--scribane-green)]" />
            </Button>
          </ButtonTooltip>
        ) : null}
        <ButtonTooltip tooltip={t('copy')} side="top">
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="group/copy-action h-7 w-7"
            aria-label={t('copy')}
            onClick={(event) => {
              event.stopPropagation();
              onCopy();
            }}
          >
            <Clipboard className="h-3.5 w-3.5 transition-transform duration-200 group-hover/copy-action:scale-110 group-hover/copy-action:text-[var(--scribane-green)]" />
          </Button>
        </ButtonTooltip>
      </div>
    </TooltipProvider>
  );
};
